export const EmailRegExp = '^$|^[a-zA-Z0-9_\\.\\-\\+\']+\\@(?:[\\w\\-]+\\.)+[a-zA-Z0-9]+$';
export const PhoneNumberRegExp = '^\\+?[\\d\\-\\s\\(\\)extX\\.]*$';
export const PhoneNumberWithoutPrefixRegExp = '^[\\d\\-\\s\\(\\)extX\\.]*$';
export const DefaultPostalCodeRegExp = '[0-9]{5}(\\-[0-9]{4})?';
export const WebsiteRegExp = '^$|(?:https?:\\/\\/)?(?:[a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*\\.)+(?:[a-zA-Z0-9]+)+(?:\\/[A-Za-z0-9-\\._~:/?#[\\]@!$&\'()*+,;=%]*)*';
export const RegGeneralInputBoxRegExp = '[^\x00-\x1F]*';
export const TaxSGGSTNumberRegExp = '^\\w{2}-?\\d{7}-?\\w$|^\\d{8,9}\\w$|^[TS]\\d{2}[A-Z]\\w\\d{4}\\w$';
export const TaxINPANNumberRegExp = '^[A-Za-z0-9]{10}$';
export const TaxRSPIBNumberRegExp = '^[0-9]{9}$|^[0-9]{13}$';
export const TaxINGSTINRegExp = '^$|^([0-9]{2}[0-9A-Z]{13})$';
export const TaxCOVatNumberRegExp = '^\\d{9}\\-\\d{1}$';
export const TaxCOCertificateExecutionDateRegExp = '^\\d{4}/\\d{2}/\\d{2}$';
export const TaxTHVATRegExp = '^$|^\\d{13}$';
export const TaxNGVATRegExp = '^$|^\\d{8}-0001$';
export const TaxAUGSTNumberRegExp = '^$|\\d{11}$';
export const TaxCAGSTNumberRegExp = '^$|^\\d{9}(\\s?RT\\d{4})?$';
export const FCARegistrationNumberRegExp = '^$|^[0-9]{6}$';
